import cn from 'classnames';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import KetoContainer from './keto-container';
import styles from './keto-design.module.css';
import KetoPaper from './keto-paper';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';

export default function KetoDesign() {
  return (
    <section className={styles.design}>
      <KetoContainer>
        <div className={styles.design_wrapper}>
          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInUp"
          >
            <KetoTypography
              variant={KetoTypographyVariant.HEADLINE_1}
              tag="h1"
              className={styles.design_title}
            >
              Design
            </KetoTypography>
          </AnimationOnScroll>

          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInUp"
            className={styles.design_container}
          >
            <div className={styles['design_colors-start']}>
              <KetoTypography
                className={styles['design_colors-title']}
                variant={KetoTypographyVariant.HEADLINE_1}
                tag="h3"
              >
                Color Palette
              </KetoTypography>
              <KetoPaper>
                <KetoTypography tag="p" variant={KetoTypographyVariant.BODY_2}>
                  Here are presented the branding guidelines for the Keto
                  Kitchen project. The primary colors are used for the buttons
                  and active states meanwhile the secondary ones represent the
                  inactive and pressed states.
                </KetoTypography>
              </KetoPaper>
            </div>
            <div className={styles['design_colors-end']}>
              <div className={styles['design_colors-row']}>
                <KetoTypography
                  className={cn(styles['design_colors-title'], styles.center)}
                  variant={KetoTypographyVariant.HEADLINE_2}
                  tag="h3"
                >
                  Main Colors
                </KetoTypography>
                <div className={styles.design_colors}>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#005448' }}
                    />
                    <KetoTypography
                      variant={KetoTypographyVariant.HEADLINE_3}
                      tag="span"
                      className={styles.design_code}
                    >
                      #005448
                    </KetoTypography>
                  </div>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#8CB2AC' }}
                    />
                    <KetoTypography
                      variant={KetoTypographyVariant.HEADLINE_3}
                      tag="span"
                      className={styles.design_code}
                    >
                      #8CB2AC
                    </KetoTypography>
                  </div>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#3D7C74' }}
                    />
                    <KetoTypography
                      variant={KetoTypographyVariant.HEADLINE_3}
                      tag="span"
                      className={styles.design_code}
                    >
                      #3D7C74
                    </KetoTypography>
                  </div>
                </div>
              </div>
              <div className={styles['design_colors-row']}>
                <KetoTypography
                  className={cn(styles['design_colors-title'], styles.center)}
                  variant={KetoTypographyVariant.HEADLINE_2}
                  tag="h3"
                >
                  Secondary Colors
                </KetoTypography>
                <div className={styles.design_colors}>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{
                        backgroundColor: '#B3CCC8',
                        border: '1px solid #266D63',
                      }}
                    />
                    <KetoTypography
                      variant={KetoTypographyVariant.HEADLINE_3}
                      tag="span"
                      className={styles.design_code}
                    >
                      #B3CCC8
                    </KetoTypography>
                  </div>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#9DBDB9' }}
                    />
                    <KetoTypography
                      variant={KetoTypographyVariant.HEADLINE_3}
                      tag="span"
                      className={styles.design_code}
                    >
                      #9DBDB9
                    </KetoTypography>
                  </div>
                  <div className={styles.design_color}>
                    <div
                      className={styles.design_circle}
                      style={{ backgroundColor: '#ABABAB' }}
                    />
                    <KetoTypography
                      variant={KetoTypographyVariant.HEADLINE_3}
                      tag="span"
                      className={styles.design_code}
                    >
                      #ABABAB
                    </KetoTypography>
                  </div>
                </div>
              </div>
            </div>
          </AnimationOnScroll>
          <img className={styles.fat} src="/keto/icons/fat.svg" alt="fat" />
          <img
            className={styles.carbs}
            src="/keto/icons/carbs.svg"
            alt="carbs"
          />
        </div>
      </KetoContainer>
    </section>
  );
}
